import React from 'react';

const BoatSvg = (props) => (
    <svg
        className="boat_svg__eds-icon--boat_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="boat_svg__eds-icon--boat_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 19.7V18h3.2l-1.8 3H5.6l-1.8-3H13v1.7h1V18h2v1.7h1zM12 6.3l4.1 5.6H12V6.3zM11 5v9H4.1L11 5zm0-3v1.2L2.1 15H11v2H2l3 5h14l3-5H12v-4h6l-6-8.4V2h-1z"
        />
    </svg>
);

BoatSvg.displayName = 'BoatSvg';
export default BoatSvg;
